export default (app) => {
  const service = app.service('api/accounts');
  service.hooks({
    before: {
      all: [],
      find: [],
      create: []
    },
    after: {
      all: [],
      find: [],
      create: []
    },

    error: {
      all: [],
      find: [],
      create: []
    }
  });
};
